// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"bbfc8cb7","153":"e43ac864","694":"ecb0ca46","720":"59e5bc9c","787":"f553b4e0"}[chunkId] + ".chunk.js";
};